import { createSelector } from '@reduxjs/toolkit'
import { Slice, BlogPageInfo } from './types'
import { PageNormalized } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

const getSlice = (state: RootState): Slice => {
  return state.blog.categoryList
}

export const getFailure = (state: RootState): boolean => {
  return getSlice(state).isFailure
}

export const getFirstLoad = (state: RootState): boolean => {
  const slice = getSlice(state)
  return slice.isFailure && !slice.payload?.items
}

export const getCategoryList = (state: RootState) => {
  const slice = getSlice(state)
  return slice.payload?.items
}

export const getCategoryBySlug = (slug: string) => createSelector(
  getSlice,
  slice => {
    return slice.payload?.items.find(({ url_key: urlKey }: any) => urlKey === slug)
  }
)

const normalizePageInfo = (pageInfo: BlogPageInfo, items: any): PageNormalized => {
  const pageSize = pageInfo?.page_size ?? 0
  const totalPages = pageInfo?.total_pages ?? 0
  const totalItems = pageInfo?.totalCount ?? 0
  return {
    pageSize: pageSize,
    currentPage: pageInfo?.current_page ?? 1,
    totalPages: totalPages,
    totalItems: totalItems
  }
}

export const getPageInfo = (slug: string) => (state: RootState) => {
  const categoryList = getCategoryBySlug(slug)(state)
  return categoryList && normalizePageInfo(categoryList.pageInfo, categoryList.postSlugs)
}
